import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import './partner-card.scss';
export default function PartnerCard({ type, href, title, logoUrl, tags, onClick, badgeImage, verifiedFeatures, analyticsContentType }) {
    const analyticsInfo = analyticsContentType
        ? {
            'data-analytics-select-content': title,
            'data-content-type': analyticsContentType,
            'data-content-tags': `,category=${type},`
        }
        : {};
    return (React.createElement("a", Object.assign({ className: "partner-card", href: href, onClick: onClick }, analyticsInfo),
        React.createElement("div", { className: "logo" },
            React.createElement("img", { src: logoUrl !== null && logoUrl !== void 0 ? logoUrl : '', alt: "" }),
            verifiedFeatures && badgeImage && (React.createElement("div", { className: "badge" },
                React.createElement("img", { className: "background", src: badgeImage, alt: "verified" }),
                React.createElement(FontAwesomeIcon, { className: "checkmark", icon: faCheck }),
                React.createElement("div", { className: "tooltip right" }, verifiedFeatures)))),
        React.createElement("div", { className: "info" },
            React.createElement("div", { className: "name" }, title),
            React.createElement("div", { className: "tags" }, tags.map((value) => (React.createElement("span", { className: "tag", key: value }, value)))))));
}
